module.exports = __webpack_public_path__ + "img/ethereum.2e2585d1.png";